<script setup lang="ts">
import { ref, watch } from 'vue'
import Autocomplete from '@/components/Autocomplete.vue'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/foundation/form'
import { assignees, categories, clients, labels, ranges, roles } from '@/views/tickets/data/data'
import AutoFormLabel from './AutoFormLabel.vue'
import type { FieldProps } from './interface'
import { beautifyObjectName } from './utils'

const props = withDefaults(defineProps<FieldProps & { showLogo: boolean }>(), { showLogo: true })
const dataTypes = [...assignees, ...categories, ...clients, ...labels, ...ranges, ...roles]
const getLabel = (labelObject: { id: string; name: string }) => {
  const dataItem = dataTypes.find((s) => s.value === labelObject?.name)

  return dataItem?.label
}
const capturedSlotPropModelValue = ref()
const autocompleteKey = ref(0)

watch(capturedSlotPropModelValue, () => {
  autocompleteKey.value++
})
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    {{
      (() => {
        capturedSlotPropModelValue = slotProps.componentField.modelValue
        return ''
      })()
    }}
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label || beautifyObjectName(label ?? fieldName) }}
      </AutoFormLabel>
      <FormControl>
        <slot v-bind="slotProps">
          <Autocomplete
            :key="autocompleteKey"
            :disabled="props.disabled"
            v-bind="props.config?.inputProps"
            :value="capturedSlotPropModelValue"
            :show-logo="showLogo"
            :label="getLabel(slotProps.componentField.modelValue) ?? slotProps.componentField.modelValue?.name"
            @update:value="slotProps.componentField['onUpdate:modelValue']"
            @open-new-contact-dialog="props.config?.inputProps?.onOpenNewContactDialog"
          />
        </slot>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
